var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    { staticClass: "back", attrs: { href: "#" } },
    [
      _c("img", {
        staticClass: "icon icon-svg",
        attrs: { src: require("@/static/svg/icono_next.svg"), alt: "back icon" }
      }),
      _vm._v(" "),
      _vm._t("default", [_vm._v("Volver")])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }